import { Link, LinkProps, MenuItem, Tooltip, Typography } from "@mui/material";
import { EdmButton } from "atoms";
import { ReactElement, RefObject, SyntheticEvent } from "react";
import { ButtonProps, useTranslate } from "react-admin";

import { CloseMenuType } from "./SimpleMenu";

export type ButtonOrMenuItemPropsType = {
  className?: string;
  label: string | null;
  labelOpts?: {
    disableTranslation?: boolean;
    [key: string]: unknown;
  };
  disabled?: boolean;
  closeMenu?: CloseMenuType;
  children?: ReactElement | null;
  smartCount?: number;
  tooltipTitle?: string | null;
  tooltipOpts?: object;
  passedRef?: RefObject<HTMLButtonElement> | null;
  onClick?: (e: SyntheticEvent) => void;
  "data-testid"?: string;
} & Partial<Omit<ButtonProps, "children"> | Omit<LinkProps, "children">>;

export default function ButtonOrMenuItem(props: ButtonOrMenuItemPropsType) {
  const {
    className,
    onClick,
    label,
    labelOpts = {},
    disabled = false,
    closeMenu = null,
    children: icon,
    smartCount = 1,
    tooltipTitle = null,
    tooltipOpts = {},
    passedRef,
    ...rest
  } = props;
  const translate = useTranslate();

  const handleMenuItemOnClick = (e: SyntheticEvent) => {
    if (disabled) return;
    onClick?.(e);
    closeMenu?.(e);
  };

  const finalLabel =
    label === null
      ? ""
      : labelOpts.disableTranslation
        ? label
        : translate(label, { ...labelOpts, smart_count: smartCount });
  const finalTooltipTitle = tooltipTitle ? translate(tooltipTitle, { ...tooltipOpts, smart_count: smartCount }) : "";

  let commonProps = {};

  if (passedRef) {
    commonProps = { ref: passedRef };
  }

  return (
    <Tooltip arrow title={finalTooltipTitle}>
      {closeMenu ? (
        <MenuItem data-testid={props["data-testid"]} onClick={handleMenuItemOnClick} {...commonProps}>
          <Typography color={disabled ? "textSecondary" : "textPrimary"}>{finalLabel}</Typography>
        </MenuItem>
      ) : (
        // <span> wrapping is necessary for the tooltip to show up
        <span>
          {icon === null ? (
            <Link
              component="button"
              variant="body1"
              className={className}
              onClick={onClick}
              data-testid={props["data-testid"]}
              disabled={disabled}
              {...commonProps}
              {...(rest as LinkProps)}
            >
              {finalLabel}
            </Link>
          ) : (
            <EdmButton
              className={className}
              onClick={onClick}
              label={finalLabel}
              data-testid={props["data-testid"]}
              disabled={disabled}
              {...commonProps}
              {...(rest as ButtonProps)}
            >
              {icon}
            </EdmButton>
          )}
        </span>
      )}
    </Tooltip>
  );
}
